<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ConnectInboxForm from './ConnectInboxForm.vue';

const props = defineProps({
  assistantId: {
    type: Number,
    required: true,
  },
  inbox: {
    type: Object,
    default: () => null,
  },
  type: {
    type: String,
    default: 'create',
  },
});
const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const connectForm = ref(null);

const i18nKey = 'CAPTAIN.INBOXES.CREATE';

const handleSubmit = async payload => {
  try {
    if (payload.isEdit) {
      await store.dispatch('captainInboxes/update', payload);
      useAlert('Configuração de etapas atualizada com sucesso!');
    } else {
      await store.dispatch('captainInboxes/create', payload);
      useAlert(t(`${i18nKey}.SUCCESS_MESSAGE`));
    }
    dialogRef.value.close();
  } catch (error) {
    const errorMessage = error?.message || t(`${i18nKey}.ERROR_MESSAGE`);
    useAlert(errorMessage);
  }
};

const handleClose = () => {
  emit('close');
};

const handleCancel = () => {
  dialogRef.value.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="create"
    :title="type === 'edit' ? 'Configurar Etapas do Funil' : $t(`${i18nKey}.TITLE`)"
    :description="type === 'edit' ? 'Defina em quais etapas do Kanban este assistente irá atuar nesta caixa de entrada.' : $t('CAPTAIN.INBOXES.FORM_DESCRIPTION')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="handleClose"
  >
    <ConnectInboxForm
      ref="connectForm"
      :assistant-id="assistantId"
      :inbox="inbox"
      :is-edit="type === 'edit'"
      @submit="handleSubmit"
      @cancel="handleCancel"
    />
    <template #footer />
  </Dialog>
</template>
